import React from "react";
import { createStyles, fade, makeStyles, Theme } from "@material-ui/core/styles";
import {
    AppBar,
    Button,
    Container,
    IconButton,
    Link,
    Menu,
    MenuItem,
    MenuList,
    Typography,
} from "@material-ui/core";
import MoreIcon from "@material-ui/icons/MoreVert";
import iliaMini from "../../../../components/client/landingPage/v2/images/ilia_small.png";
import {
    LOGO_BASE_URL,
    kaiZenRebrand, kaiZenPhysicianRebrand, getMaskedNumber,
} from "../../../../constants";
import LandingContactForm from "../v2/LandingContactForm";

const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            grow: {
                flexGrow: 1,
            },
            floatRight: {
                float: "right",
            },
            menuList:{
              float:"right",
                padding:0,
            },
            topHeader: {
                background: "#203053",
                color: "#ffffff",
                float: "left",
                width: "100%",
                position: "fixed",
                top: 0,
                zIndex: 1300,
                padding:"5px 10px",
            },
            topHeaderItem: {
                float:'left',
                padding:"0 10px",
                fontSize: "16px !important",
                [theme.breakpoints.down("sm")]: {
                    padding:"0 5px",
                },
                a: {
                    color: "#FFFFFF !important",
                    padding:0,
                },
            },
            topHeaderItemLink: {
                color: "#ffffff !important",
                display: "flex",
                alignItems: "center",
                textDecoration:'none',
                padding:0,
            },

            menuButton: {
                marginRight: theme.spacing(2),
            },
            title: {
                display: "none",
                [theme.breakpoints.up("sm")]: {
                    display: "block",
                },
            },
            search: {
                position: "relative",
                borderRadius: theme.shape.borderRadius,
                backgroundColor: fade(theme.palette.common.white, 0.15),
                "&:hover": {
                    backgroundColor: fade(theme.palette.common.white, 0.25),
                },
                marginRight: theme.spacing(2),
                marginLeft: 0,
                width: "100%",
                [theme.breakpoints.up("sm")]: {
                    marginLeft: theme.spacing(3),
                    width: "auto",
                },
            },
            searchIcon: {
                padding: theme.spacing(0, 2),
                height: "100%",
                position: "absolute",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },
            inputRoot: {
                color: "inherit",
            },
            inputInput: {
                padding: theme.spacing(1, 1, 1, 0),
                // vertical padding + font size from searchIcon
                paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
                transition: theme.transitions.create("width"),
                width: "100%",
                [theme.breakpoints.up("md")]: {
                    width: "20ch",
                },
            },
            sectionDesktop: {
                display: "none",
                [theme.breakpoints.up("md")]: {
                    display: "flex",
                },
            },
            sectionMobile: {
                display: "flex",
                [theme.breakpoints.up("md")]: {
                    display: "none",
                },
            },
            logo: {
                maxHeight: 60,
                margin: 10,
            },

        }),
);

export default function PrimarySearchAppBar(props: any) {
    const { role } = props;
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [scrollClass, setScrollClass] = React.useState<string>("");
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 992);
    const [open, setOpen] = React.useState(false);
    const startegyLogo: string = props.strategyData.logo;
    const clientPolicy = props.client && props.client.clientPolicies && props.client.clientPolicies.length > 0 && props.client.clientPolicies[0];
    let clientLogo: string = clientPolicy && clientPolicy.clientLogo ? LOGO_BASE_URL + clientPolicy.clientLogo : (props.agent && props.agent.companyLogo ? LOGO_BASE_URL + props.agent.companyLogo : "");
    let groupUserLogo = false;
    if (props.groupDetail && props.groupDetail.user && props.groupDetail.user.image) {
        clientLogo = LOGO_BASE_URL + props.groupDetail.user.image;
        groupUserLogo = true;
    }
    let partnerLogo: string = iliaMini;
    if (props.strategyData && props.strategyData.reBrand === 1 && props.strategyData.reBrandLogo) {
        let isExist: boolean = props.strategyData.reBrandLogo.includes("s3.amazonaws.com");
        if (isExist) {
            partnerLogo = props.strategyData.reBrandLogo;
        } else {
            partnerLogo = LOGO_BASE_URL + props.strategyData.reBrandLogo;
        }
    }
    if (props.strategyData && props.strategyData.reBrand === 2 && props.agent && props.agent.imo && props.agent.imo.reBrand && props.strategyData.reBrandLogo) {
        let isExist: boolean = props.strategyData.reBrandLogo.includes("s3.amazonaws.com");
        if (isExist) {
            partnerLogo = props.strategyData.reBrandLogo;
        } else {
            partnerLogo = LOGO_BASE_URL + props.strategyData.reBrandLogo;
        }
    }
    const { ALLOWED_ACCOUNT_TYPE, accountType } = props;

    React.useEffect(() => {
        window.addEventListener("scroll", () => {
            let activeClass: string = "scroll-normal";
            if (window.scrollY === 0) {
                activeClass = "scroll-top";
            }
            setScrollClass(activeClass);
        });

        window.addEventListener("resize", handleResize);
        return (() => {
            window.removeEventListener("scroll", handleResize);
        });
    }, []);


    const handleResize = (e: any) => {
        setIsMobile(window.innerWidth < 992);
    };


    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const goToDashboard = async () => {
        window.location.href = "/dashboard";
    };

    const menuId = "primary-search-account-menu";
    let redirectUrl: string = props && props.match && props.match.url;
    let searchParams: string = props && props.location.search;
    let encodeUrl: string = "";
    let url: string = "";
    encodeUrl = btoa(redirectUrl);
    if (searchParams) {
        encodeUrl = btoa(redirectUrl + searchParams);
    }
    if (redirectUrl) {
        url = `/login?token=${encodeUrl}`;
    }
    const renderMenu = (
            <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    id={menuId}
                    keepMounted
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    open={isMenuOpen}
                    onClose={handleMenuClose}
            >
                {props.startEstimation < 3 && role != 6 &&
                        <MenuItem>
                            {accountType !== ALLOWED_ACCOUNT_TYPE.INDIVIDUAL &&
                                    <Link
                                            variant="caption"
                                            className="mr30"
                                            rel="noopener noreferrer"
                                            href="http://www.kaizenplan.com/agents"
                                            target="_blank">KaiZen Plan Agent Login</Link>
                            }
                            <Link variant="caption" onClick={() => {
                                window.location.href = url;
                            }}>ilia Login</Link>
                        </MenuItem>
                }
                {props.startEstimation === 0 &&
                        <MenuItem>
                            <Button size="large" onClick={() => props.setStartEstimation(1)} variant="contained"
                                    color="primary">
                                Get Started: Estimate Benefits
                            </Button>
                        </MenuItem>
                }
                {props.startEstimation === 3 &&
                        <MenuItem onClick={() => goToDashboard()}>
                            <Typography>Welcome <span className="textCapitalize">{props.firstName}</span> <Typography
                                    component="span"
                                    color="primary"> Go to your Dashboard</Typography></Typography>

                        </MenuItem>
                }
            </Menu>
    );

    const mobileMenuId = "primary-search-account-menu-mobile";
    const renderMobileMenu = (
            <Menu
                    anchorEl={mobileMoreAnchorEl}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    id={mobileMenuId}
                    keepMounted
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    open={isMobileMenuOpen}
                    onClose={handleMobileMenuClose}
            >
                {props.startEstimation < 3 && role != 6 &&
                        <MenuItem>
                            { accountType !== ALLOWED_ACCOUNT_TYPE.INDIVIDUAL &&
                                    <Link
                                            variant="caption"
                                            className="mr30"
                                            rel="noopener noreferrer"
                                            href="http://www.kaizenplan.com/agents"
                                            target="_blank">KaiZen Plan Agent Login</Link>
                            }
                            <Link variant="caption" onClick={() => {
                                window.location.href = url;
                            }}>ilia Login</Link>
                        </MenuItem>
                }
                {props.startEstimation === 0 &&
                        <MenuItem>
                            <Button size="large" onClick={() => props.setStartEstimation(1)} variant="contained"
                                    color="primary">
                                Get Started: Estimate Benefits
                            </Button>
                        </MenuItem>
                }
                {props.startEstimation === 3 &&
                        <MenuItem onClick={() => goToDashboard()}>
                            <Link color="primary">Welcome <span className="textCapitalize">{props.firstName}</span> Go
                                to your
                                Dashboard </Link>
                        </MenuItem>
                }
            </Menu>
    );
    const ImagesDiv = () => {
        // case of AON carrier and Leveraged Savings Plan – Physicians or Leveraged Savings Plan strategy
        if (props.strategy && props.strategy.name && props.strategy.reBrand && props.strategy.slug == "kaizen"
                && (props.strategy.id == kaiZenRebrand || props.strategy.id == kaiZenPhysicianRebrand)) {
            return (<div className="footerImg floatLeft">
                {partnerLogo &&
                        <img alt={"partnerLogo"} src={partnerLogo} className="partnerLogo" />
                }
                {startegyLogo ?
                        <img alt={"strategylogo"} className="partnerLogo" src={startegyLogo} /> :
                        <Typography color="primary" component="strong" className="f22 ml15 mt10 mb0 floatLeft">
                            {props.strategyData.name}
                        </Typography>
                }
            </div>);
        }
        return (
                <div className="footerImg floatLeft">
                    <img alt={"partnerlogo"} src={partnerLogo} className="partnerLogo" />
                    { startegyLogo ?
                            <img alt="strategylogo" className="partnerLogo" src={startegyLogo} /> :
                            <Typography color="primary" component="strong" className="f22 ml15 mt10 floatLeft">
                                {props.strategyData.name}
                            </Typography>
                    }
                    {(clientLogo && !groupUserLogo) && <div className="Vdivider">
                        <img alt="clientlogo" className="partnerLogo ml15" src={clientLogo} />
                    </div>
                    }
                </div>
        );
    };

    const phone: string = props.groupDetail ? getMaskedNumber(props.groupDetail.phone + "") : "800-294-9940";

    // const defaultPhoneNumber = '';
    const menuItems = [
        {href: `tel:${phone}`, label: phone},
        {href: `#`, label: 'Contact us', onClick:() => setOpen(true)},
        {href: 'https://www.myilia.com/login', label: 'User Login'},
    ];



    return (
            <>
                <div className={classes.topHeader + " " + classes.floatRight}>
                    <Container maxWidth="lg">
                        <MenuList className={classes.menuList}>
                            {
                                menuItems.map(({ label, href , ...content}, idx) => (
                                        <MenuItem className={classes.topHeaderItem} key={idx}>
                                            <a {...content} href={href} className={classes.topHeaderItemLink}>
                                                {label}
                                            </a>
                                        </MenuItem>
                                ))
                            }
                        </MenuList>
                        <LandingContactForm setOpen={(isOpen: boolean) => setOpen(isOpen)} open={open} {...props} />
                    </Container>
                </div>
                <div className={classes.grow}>
                    <AppBar position="fixed" color="secondary" className={`header ${scrollClass}`} style={{top:34}}>
                        <Container maxWidth="lg">
                            <ImagesDiv />
                            <div className={classes.grow} />
                            { clientLogo && groupUserLogo &&
                                    <img alt={"CompanyLogo"} className="logo ml15 floatRight" src={clientLogo} />
                            }
                            <div className={classes.sectionDesktop + " floatRight " }>
                                {props.startEstimation < 3 && role != 6 &&
                                        <MenuItem>
                                            { accountType !== ALLOWED_ACCOUNT_TYPE.INDIVIDUAL &&
                                                    <Link
                                                            variant="caption"
                                                            className="mr30"
                                                            rel="noopener noreferrer"
                                                            href="http://www.kaizenplan.com/agents"
                                                            target="_blank">KaiZen Plan Agent Login</Link>
                                            }
                                            <Link variant="caption" onClick={() => {
                                                window.location.href = url;
                                            }}>ilia Login</Link>
                                        </MenuItem>
                                }
                                { props.startEstimation === 0 &&
                                        <MenuItem className="mb0">
                                            <Button size="large" onClick={() => props.setStartEstimation(1)}
                                                    variant="contained" color="primary">
                                                Get Started: Estimate Benefits
                                            </Button>
                                        </MenuItem>
                                }
                                { props.startEstimation === 3 &&
                                        <MenuItem
                                                className={isMobile ? "mb0" : "mb0 second-step"}
                                                onClick={() => goToDashboard()}>
                                            <Typography variant="caption">Welcome <span
                                                    className="textCapitalize">{props.firstName}</span>
                                                <Button size="large" onClick={() => goToDashboard()} className=" ml15"
                                                        variant="contained"
                                                        color="primary">
                                                    Learn More on Your Dashboard
                                                </Button>
                                            </Typography>
                                        </MenuItem>
                                }
                            </div>
                            {
                                    ( (props.startEstimation < 3 && role != 6) || props.startEstimation === 0 || props.startEstimation === 3) &&
                                    <div className={`${classes.sectionMobile + " floatRight "}`}>
                                        <IconButton
                                                aria-label="show more"
                                                aria-controls={mobileMenuId}
                                                aria-haspopup="true"
                                                onClick={handleMobileMenuOpen}
                                                color="inherit"
                                                className={isMobile ? "second-step" : ""}
                                        >
                                            <MoreIcon />
                                        </IconButton>
                                    </div>
                            }
                            { renderMobileMenu }
                            { renderMenu }
                        </Container>
                    </AppBar>
                </div>
            </>
    );
}
